// extracted by mini-css-extract-plugin
export var wrapper = "layout-module--wrapper--Owhnb";
export var wrapperColourAlternate = "layout-module--wrapperColourAlternate--3BbfD";
export var textColourAlternate = "layout-module--textColourAlternate--W1cl4";